(function () {
  const experiment = 'homepage-v2';
  const allowedVariants = new Set(['field-notes', 'trail-kit']);
  const campaignMediaBySource = Object.freeze({
    meta: 'paid_social',
    tiktok: 'paid_social',
    google: 'cpc',
  });
  const analyticsRetryDelayMs = 125;
  const analyticsMaxAttempts = 8;
  const parameters = new URLSearchParams(window.location.search);
  const requestedVariant = parameters.get('bm_exp');
  const variant = allowedVariants.has(requestedVariant) ? requestedVariant : 'field-notes';
  const utmSource = (parameters.get('utm_source') || '').trim().toLowerCase();
  const utmMedium = (parameters.get('utm_medium') || '').trim().toLowerCase();
  const utmCampaign = (parameters.get('utm_campaign') || '').trim().toLowerCase();
  const utmContent = (parameters.get('utm_content') || '').trim().toLowerCase();
  const qaSuppressed = parameters.has('qa') || utmSource === 'barkmio_internal';
  const campaignCoherent =
    allowedVariants.has(requestedVariant) &&
    utmCampaign === 'homepage_v2' &&
    utmContent === variant &&
    campaignMediaBySource[utmSource] === utmMedium;
  const eligible = campaignCoherent && !qaSuppressed;
  const assignment = eligible
    ? 'campaign-url'
    : allowedVariants.has(requestedVariant)
      ? 'manual-url'
      : 'default';

  document.documentElement.dataset.bmExperience = variant;
  window.BarkmioExperience = Object.freeze({
    experiment,
    variant,
    assignment,
    eligible,
    qaSuppressed,
  });

  function publish(name, data, attempt) {
    if (!eligible || qaSuppressed) return;
    const currentAttempt = attempt || 1;
    const publisher = window.Shopify?.analytics?.publish;
    if (typeof publisher !== 'function') {
      if (currentAttempt < analyticsMaxAttempts) {
        setTimeout(function () {
          publish(name, data, currentAttempt + 1);
        }, analyticsRetryDelayMs);
      }
      return;
    }
    try {
      Promise.resolve(publisher.call(window.Shopify.analytics, name, data)).catch(function () {});
    } catch (error) {
      // Analytics must never interrupt storefront navigation or event binding.
    }
  }

  function eventData(extra) {
    return Object.assign(
      {
        event_version: 2,
        experiment,
        variant,
        assignment,
        eligible,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        locale: document.documentElement.lang || '',
        path: window.location.pathname,
      },
      extra || {},
    );
  }

  function productHandle(destination) {
    const match = destination.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function sectionName(link) {
    const section = link.closest('.shopify-section');
    if (!section?.id) return '';
    return section.id.split('__').pop() || section.id;
  }

  function selectedVariantIsRendered(main) {
    const selectedContent = main.querySelector(
      `[id$="__image_banner"] .bm-experience-content--${variant}`,
    );
    if (!selectedContent) return false;
    if (typeof selectedContent.checkVisibility === 'function') {
      try {
        return selectedContent.checkVisibility();
      } catch (error) {
        // Fall through for browsers without a complete checkVisibility implementation.
      }
    }
    return (
      typeof selectedContent.getClientRects === 'function' &&
      selectedContent.getClientRects().length > 0
    );
  }

  function initializeFlagshipCarousel(main) {
    const controls = main.querySelector('[data-bm-flagship-controls]');
    const rail = main.querySelector('[data-bm-flagship-rail]');
    const slides = rail ? Array.from(rail.querySelectorAll('[data-bm-flagship-slide]')) : [];
    const previous = controls?.querySelector('[data-bm-flagship-previous]');
    const next = controls?.querySelector('[data-bm-flagship-next]');
    const current = controls?.querySelector('[data-bm-flagship-current]');
    if (!controls || !rail || !previous || !next || !current || slides.length < 2) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let animationFrame = 0;

    function closestSlideIndex() {
      const railLeft = rail.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      slides.forEach(function (slide, index) {
        const distance = Math.abs(slide.getBoundingClientRect().left - railLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    }

    function updateControls() {
      activeIndex = closestSlideIndex();
      current.textContent = String(activeIndex + 1);
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === slides.length - 1;
    }

    function scrollToSlide(index) {
      const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
      const left = target.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
      rail.scrollTo({
        left,
        behavior: reduceMotion.matches ? 'auto' : 'smooth',
      });
    }

    previous.addEventListener('click', function () {
      scrollToSlide(activeIndex - 1);
    });
    next.addEventListener('click', function () {
      scrollToSlide(activeIndex + 1);
    });
    rail.addEventListener(
      'scroll',
      function () {
        if (animationFrame) return;
        animationFrame = requestAnimationFrame(function () {
          animationFrame = 0;
          updateControls();
        });
      },
      { passive: true },
    );
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  function initialize() {
    const main = document.querySelector('main');
    if (!main) return;

    initializeFlagshipCarousel(main);

    main.querySelectorAll('a[href]').forEach(function (link) {
      const destination = link.getAttribute('href') || '';
      link.setAttribute('data-bm-track', 'homepage-link');
      link.addEventListener(
        'click',
        function () {
          publish(
            'barkmio:homepage_cta_clicked',
            eventData({
              destination,
              label: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 80),
              product_handle: productHandle(destination),
              section: sectionName(link),
            }),
          );
        },
        { once: true },
      );
    });

    if (selectedVariantIsRendered(main)) {
      publish('barkmio:homepage_exposure', eventData());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
